import { Product } from "tm-shared/types";

import { useFilters, useProductsSort } from "@/domains/product";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setProductsSortTag } from "@/store/slices/ui";

interface UseOfflineFilteredProductsProps {
    products: Record<string, Product>;
    inventoryList?: Record<string, number>;
    mmlList?: Record<string, boolean>;
}

export const useOfflineFilteredProducts = ({
    products,
    inventoryList = {},
    mmlList,
}: UseOfflineFilteredProductsProps) => {
    const dispatch = useAppDispatch();
    const { sort, selectedFilters, showOnlyMML, hideZeroProducts } =
        useAppSelector((s) => s.ui.productsFilter);

    const { filteredProducts, availableFilters } = useFilters({
        products,
        inventoryList,
        filters: selectedFilters,
        hideZeroProducts,
        showOnlyMML,
        mmlList,
    });

    const { sorted, options, value, order } = useProductsSort({
        items: filteredProducts,
        tag: sort.tag,
        order: sort.order,
        onTagChange: (tag) => dispatch(setProductsSortTag(tag)),
    });

    return {
        availableFilters,
        availableProductsLength: sorted.length,
        hideZeroProducts,
        selectedFilters,
        showOnlyMML,
        sortOptions: options,
        sortOrder: order,
        sortTag: value,
        sortedProducts: sorted,
    };
};
